import { useEffect } from 'react'

import platform from 'components/Trackers/platform'
import { useTracking } from 'utils/analytics/useTracking'

export const useCheckingFundingTracking = () => {
  const track = useTracking(screenViewed)

  return {
    directDepositTapped: () => track.buttonTapped(selectionTapped('direct_deposit')),
    bankLinkingTapped: () => track.buttonTapped(selectionTapped('funding_source')),
    pinWheelModalOpen: () => track.eventOccurred(pinWheelModalOpen),
    pinWheelSuccess: () => track.eventOccurred(pinWheelSuccess),
    pinwheelErrorToast: () => track.containerViewed(pinwheelErrorToast),
  }
}

export const useDirectDepositDisclosureTracking = (isOpen: boolean) => {
  const track = useTracking()

  useEffect(() => {
    if (isOpen) {
      track.containerViewed(disclosureViewed)
    }
  }, [isOpen])
}

const sharedProps = {
  platform,
  card_type: 'moc',
  context: 'registration',
  screen: 'registrationSpendFundingSource',
  screen_name: 'registrationSpendFundingSource',
}

const screenViewed = {
  object: 'Screen',
  action: 'Viewed',
  object_name: 'registrationSpendFundingSource',
  ...sharedProps,
}

type SelectionType = 'direct_deposit' | 'funding_source'

const selectionTapped = (type: SelectionType) => ({
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationSpendFundingSourceSelection',
  type,
  ...sharedProps,
})

const disclosureViewed = {
  object: 'Container',
  action: 'Viewed',
  object_name: 'bankingDirectDepositDisclosure',
  ...sharedProps,
}

const pinWheelModalOpen = {
  object_name: 'bankingDirectDepositPinwheel',
  screen: 'bankingDirectDepositPinwheel',
  pinwheel_event: 'OPEN',
  ...sharedProps,
}

const pinWheelSuccess = {
  object_name: 'bankingDirectDepositPinwheel',
  screen: 'bankingDirectDepositPinwheel',
  pinwheel_event: 'SUCCESS',
  ...sharedProps,
}

const pinwheelErrorToast = {
  object: 'Container',
  action: 'Viewed',
  object_name: 'pinwheelErrorToast',
  ...sharedProps,
}
